import React, { Component } from 'react'


export default class StickyMove extends Component {

    constructor(props) {
        super(props)
        this.state = {
            posX: 0,
            posY: 0
        }
    }

    cbackFx = () => {     
        this.props.cback(this.state.posX, this.state.posY)
    }

    moveFx = (e) => {

        this.setState({
            posX : e.pageX,
            posY: e.pageY
        })
        
    }


    render() {

        const wrapStyle = {
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100vw',
            height: '100vh',
            cursor: 'move',
            zIndex: 98
        }

        return (

            <div style={wrapStyle} onClick={this.cbackFx} onMouseMove={this.moveFx}>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/sticky/StickyMove.js